<style lang="scss" scoped>
.inbound-info > span {
	display: inline-block;
	width: 33%;
	padding: 6px 0;
}
</style>

<template>
	<section class="margin-15 relative">
		<template>
			<div style="margin-bottom: -20px" v-if="type !== 'query'">
				<vFormItem label-width="auto" inline :label="$t('fbb.markchange.sku_before_change',{ defaultValue: '换标前SKU'}) + ':'" class="margin-right-10" required prop="sku">
					<vInput v-model="formData.sku" readonly suffix="search" @on-icon-click="handleSkuErp"></vInput>
				</vFormItem>
                <vFormItem label-width="auto" inline :label="$t('fbb.alloment.inventory_available',{ defaultValue: '可用库存'}) + ':'" class="margin-right-10">
					{{formData.inventoryAvailable || 0}}
				</vFormItem>
				<vFormItem label-width="auto" inline :label="$t('fbb.alloment.off_shelf_quantity',{ defaultValue: '下架数量'}) + ':'" class="margin-right-10" required prop="qty">
					<vInputNumber clearable v-model="formData.qty" :min="1" math="round" />
				</vFormItem>
                <vFormItem label-width="auto" inline :label="$t('fbb.markchange.sku_after_change',{ defaultValue: '换标后SKU'}) + ':'" class="margin-right-10" required prop="newSku">
					<vInput v-model="formData.newSku" readonly suffix="search" @on-icon-click="handleSkuErpNew"></vInput>
				</vFormItem>
                <vFormItem label-width="auto" inline :label="$t('fbb.alloment.on_shelf_quantity',{ defaultValue: '上架数量'}) + ':'" class="margin-right-10" required prop="newQty">
					<vInputNumber clearable v-model="formData.newQty" :min="1" math="round" />
				</vFormItem>
				<vButtonGroup class="inline">
					<vButton theme="primary" @click="addItem(formData)">{{$t('global.common.add',{defaultValue:'添加'})}}</vButton>
					<vButton @click="handleUploadData">{{$t('global.common.import',{defaultValue:'导入'})}}</vButton>
					<vButton @click="clearAll">{{$tc('global.common.clear',2,{defaultValue:'清空'})}}</vButton>
				</vButtonGroup>
			</div>
		</template>
        <!-- <div class="inbound-info" v-if="type == 'query'">
            <span>{{$t('',{defaultValue:'SKU种类合计'})}}{{baseData.planQty}}</span>
            <span>{{$t('',{defaultValue:'计划下架总数'})}}{{baseData.planSoldOut}}</span>
            <span>{{$t('',{defaultValue:'实际下架总数'})}}{{baseData.actualSoldOut}}</span>
            <span>{{$t('',{defaultValue:'计划上架总数'})}}{{baseData.planPutaway}}</span>
            <span>{{$t('',{defaultValue:'实际上架总数'})}}{{baseData.actualPutaway}}</span>
        </div> -->
		<Table v-if="type !== 'query'" style="max-height:200px;overflow:auto" class="margin-top-10" :columns="columns1" size="small" :data="dataList" border></Table>
		<Table v-else style="max-height:200px;overflow:auto" class="margin-top-10" :columns="columns2" size="small" :data="dataList" border></Table>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
			/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { } from '@/service/misc';

import compErpsku from '../markchangecustom/erpsku'

export default {
	props: ['data', 'baseData', 'status','PoNos','proinblundList','detailtype','querytype','activeid','isManage'],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compUpload: () => import("@components/templates/upload"),
		compModal: () => import("@components/templates/modal"),
		compErpsku,
	},
	data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
			id: this.activeid || this.$route.query.id,
			formData: {},
			dataList: this.data || [],
			poNos:"",
			erpSkuData: {},
			checkedData: [],
			modalProps: {
				show: false,
				formdata: null,
			},
			showbtnpur:false,
            inboundPlanOrderPoItemList:[],
            proData:{},
			operate:{
                show: false
			}
		}
	},
	watch: {
        activeid (activeid) {
            if (!activeid) return;
            this.id = activeid;
        },
		baseData(val) {
			this.dataList = val.changeLabelOrderItemEntities;
		}
	},
	computed: {
		columns1() {
			return [
                {
                    title: this.$t('fbb.markchange.sku_before_change',{ defaultValue: '换标前SKU'}),
                    key: 'sku',
                    render: (h, { row }) => {
                        return <div>{row.sku}</div>
                    }
                },
                {
                    title: this.$t('fbb.markchange.sku_before_change_name_chen',{ defaultValue: '换标前SKU名称(中/英)'}),
                    key: 'productName',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.productName}</div>
                            <div>{row.productNameEn}</div>
                        </div>
                    }
                },
				{
                    title: this.$t('fbb.alloment.off_shelf_quantity',{ defaultValue: '下架数量'}),
                    key: 'qty'
                },
                {
                    title: this.$t('fbb.markchange.sku_after_change',{ defaultValue: '换标后SKU'}),
                    key: 'newSku',
                },
                {
                    title: this.$t('fbb.markchange.sku_after_change_name_chen',{ defaultValue: '换标后SKU名称(中/英)'}),
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.newProductName || '--'}</div>
                            <div>{row.newProductNameEn || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.alloment.on_shelf_quantity',{ defaultValue: '上架数量'}),
                    key: 'newQty',
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: "操作" }),
                    width: 120,
                    align: 'center',
                    render: (h, { row }) => {
                        return h('Button', {
                            nativeOn: {
                                click: () => {
                                    this.removeItems(row)
                                }
                            }
                        }, this.$t('global.common.delet', { defaultValue: "删除" }))
                    }
                }
            ]
		},
        columns2() {
			return [
                {
                    title: this.$t('fbb.markchange.sku_after_change',{ defaultValue: '换标后SKU'}),
                    key: 'sku'
                },
                {
                    title: this.$t('fbb.alloment.on_shelf_quantity',{ defaultValue: '上架数量'}),
                    key: 'processQty',
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt'
                }
            ]
		}
	},

	methods: {
		//查询ERPSKU
		handleSkuErp() {
			this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
                    lineId: this.baseData.lineId,
				},
				on: {
					'on-data': (row) => {
						const { id: productId = '', sku = '', lineId = '', productName = '', productNameEn = '', inventoryAvailable = ''} = row;
                        this.formData = { ...this.formData, qty: this.formData.qty, inventoryAvailable, productId, sku, lineId, productName, productNameEn};
						this.modalProps.show = false;
					}
				},
			}
		},
        //查询ERPSKU
		handleSkuErpNew() {
			this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
                    lineId: this.baseData.lineId,
				},
				on: {
					'on-data': (row) => {
						const { sku = '', productName = '', productNameEn = ''} = row;
                        this.formData = { ...this.formData, newQty: this.formData.newQty, newSku: sku, newProductName: productName, newProductNameEn: productNameEn};
						this.modalProps.show = false;
					}
				},
			}
		},
		//上传数据
		handleUploadData() {
			this.modalProps = {
				show: true,
				title: this.$t('global.common.import', { defaultValue: '导入数据' }),
				component: "compUpload",
				showFooter: false,
				width: "middle",
				props: {
					// ajaxRequest: HttpImportProducts,
					name: "multipartFile",
					download: () => {
						this.handleWebfs("/static/template/inbound_product.xlsx", {}, {
							executor: 'download',
							type: 'url'
						});
					},
				},
				on: {
					'on-success': (row) => {
						Object.values(row.data || []).forEach((item) => {
							this.addItem(item);
                        })
						this.modalProps.show = false;
					}
				},
			}
		},
		addItem(data) {
			const { sku, qty, newSku, newQty } = data;
			if (sku && qty && newSku && newQty) {
				const erpSkuData = this.dataList.find((item) => {
					return item.sku === sku
				});
				if (erpSkuData) {
					erpSkuData.qty += qty;
				} else {
					this.dataList.push(data)
				}
				this.formData = {};
				return;
			}
            this.$VMessage.warning(this.$t('', { defaultValue: '请填写必填项！' }));
		},
		clearAll() {
			this.modalProps = {
				show: true,
				title: this.$tc('global.common.clear', 1, { defaultValue: '清空所有' }),
				alert: 'error',
				ajaxRequest: async () => {
                    this.dataList = [];
                    this.baseData.planQty = '';
                    this.proData.planQty = '';
                    this.baseData.totalVolume = '';
                    this.$set(this.proData,'totalVolume','')
                    this.baseData.totalWeight = '';
                    this.$set(this.proData,'totalWeight','')
					return { message: this.$t('global.common.haveto_empty', { defaultValue: '已清空' }) };
				}
			}
		},
		removeItems(obj) {
			this.modalProps = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
				ajaxRequest: async () => {
					this.dataList = this.dataList.filter((row) => {
						return row.sku !== obj.sku
                    })
					return { message: this.$t('global.common.have_deleted', { defaultValue: '已删除' }) };
				}
			}
        },
        onupdate(){
            this.$emit('on-updatelist')
        }

	}
}
</script>
